import { Controller } from "@hotwired/stimulus"
import { patch, get } from "@rails/request.js"
import { debounce } from "../helpers/timing_helpers"

export default class extends Controller {
  static targets = ["display", "editor", "combobox"]
  static classes = ["hidden"]
  static values = { src: String }

  connect() {
    this.close = debounce(this.close.bind(this), 150)
  }

  disconnect() {
    if (typeof this.close.cancel === "function") this.close.cancel()
  }

  edit() {
    if (!this.editorTarget.classList.contains(this.hiddenClass)) return

    this.displayTarget.classList.add(this.hiddenClass)
    this.editorTarget.classList.remove(this.hiddenClass)

    // Fetch fresh options every time we enter edit mode
    this.#fetchOptions()

    requestAnimationFrame(() => {
      this.comboboxTarget.focus()
    })
  }

  async close() {
    if (this.element.contains(document.activeElement)) return

    const saved = await this.#save()

    // Always return to display mode
    this.editorTarget.classList.add(this.hiddenClass)
    this.displayTarget.classList.remove(this.hiddenClass)

    if (!saved) {
      // TODO: surface error to user (e.g. wa-alert or turbo stream error response)
      this.dispatch("saveError")
    }
  }

  // Private

  async #fetchOptions() {
    const url = new URL(this.srcValue, window.location.origin)
    await get(url.toString(), { responseKind: "turbo-stream" })
  }

  async #save() {
    const form = this.comboboxTarget.closest("form")
    if (!form) return true

    const response = await patch(form.action, {
      body: new FormData(form),
      responseKind: "turbo-stream"
    })

    if (!response.ok) {
      console.error("Failed to save labels", response.statusCode)
    }

    return response.ok
  }
}
